// extracted by mini-css-extract-plugin
export default {"entityIcon":"EntityIcon_entityIcon__7F7ZT","organization":"EntityIcon_organization__jUnpm","person":"EntityIcon_person__Iktce"};